import { Exercises } from "@/components/exercises";
import { MobilePageTitle } from "@/components/ui/mobile-page-title";
import { ScrollableContainer } from "@/components/ui/scrollbar";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/(protected)/management/exercises/")({
  component: ExercisesComponent,
});

function ExercisesComponent() {
  const { t } = useTranslation();

  return (
    <ScrollableContainer>
      <MobilePageTitle className="mx-6 mt-5">
        {t("pages:exercise.title")}
      </MobilePageTitle>
      <Exercises />
    </ScrollableContainer>
  );
}
